import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ExamsQSelection from "../ExamsComponents/ExamsQSelection";
import ExamsTimer from "../ExamsComponents/ExamsTimer";
import ExamsFStyle from "../styles&pics/ExamsFStyle";
import Captcha from "../UtilityComponents/Captcha";


const ExamsForm = () => {
    const selectedQuestions = ExamsQSelection();
    const [submittedAnswers, setSubmittedAnswers] = useState([]);
    const [hp, setHp] = useState(null);
    const [isVerified, setIsVerified] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [answers, setAnswers] = useState({});

    const navigate = useNavigate();
    console.log(selectedQuestions);

    const handleNext = () => {
        if (currentStep < selectedQuestions.length - 1) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handlePrevious = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleAnswerChange = (questionId, field, value) => {
        setAnswers(prev => ({
            ...prev,
            [questionId]: {
                ...prev[questionId],
                [field]: value
            }
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        if(formData.get('hp') !== null) {
            return
        }
        const finalAnswers = selectedQuestions.map((question) => ({
            questionId: question.erid,
            answerText: answers[question.erid]?.answerText || '',
            codeAnswer: answers[question.erid]?.codeAnswer || '',
            imagePath: answers[question.erid]?.imagePath || '',
        }));
        setSubmittedAnswers(finalAnswers);
    };

    useEffect(() => {
        if (submittedAnswers.length > 0) {
            navigate('/ExamsAnswerLoader', {
                state: {
                    submittedAnswers,
                    selectedQuestions,
                },
            });
        }
    }, [submittedAnswers, navigate, selectedQuestions]);

    const currentQuestion = selectedQuestions[currentStep];
    const progress = ((currentStep + 1) / selectedQuestions.length) * 100;

    return (
        <>
            <ExamsFStyle />
            <main className="exams-form-main">
                <div className="exams-form-container">
                    <div className="exams-form-header">
                        <h2>Εξετάσεις</h2>
                        <ExamsTimer />
                    </div>

                    <div className="progress-bar-container">
                        <div className="progress-bar" style={{ width: `${progress}%` }}></div>
                        <span className="progress-text">Ερώτηση {currentStep + 1} από {selectedQuestions.length}</span>
                    </div>

                    <form id="form" onSubmit={handleSubmit}>
                        {currentQuestion && (
                            <div className="question-card">
                                <p className="question-text">
                                    Ερώτηση {currentStep + 1}: {currentQuestion.erwthsh} (Βάρος Βαθμολόγησης={currentQuestion.Vathmos})
                                </p>
                                {currentQuestion.apanthsh ? (
                                    <textarea
                                        value={answers[currentQuestion.erid]?.answerText || ''}
                                        onChange={(e) => handleAnswerChange(currentQuestion.erid, 'answerText', e.target.value)}
                                        rows="4"
                                        placeholder="Απάντηση κειμένου"
                                        className="answer-textarea"
                                    ></textarea>
                                ) : null}
                                {currentQuestion.code_content ? (
                                    <textarea
                                        value={answers[currentQuestion.erid]?.codeAnswer || ''}
                                        onChange={(e) => handleAnswerChange(currentQuestion.erid, 'codeAnswer', e.target.value)}
                                        rows="4"
                                        placeholder="Γράψε τον κώδικά σου εδώ..."
                                        className="answer-textarea"
                                    ></textarea>
                                ) : null}
                                {currentQuestion.Path ? (
                                    <input
                                        type="file"
                                        onChange={(e) => handleAnswerChange(currentQuestion.erid, 'imagePath', e.target.files[0])}
                                        accept="image/png, image/jpeg"
                                        className="file-input"
                                    />
                                ) : null}
                            </div>
                        )}

                        <div className="navigation-buttons">
                            <button 
                                type="button" 
                                onClick={handlePrevious} 
                                disabled={currentStep === 0}
                                className="nav-button prev-button"
                            >
                                ← Προηγούμενη
                            </button>
                            
                            {currentStep < selectedQuestions.length - 1 ? (
                                <button 
                                    type="button" 
                                    onClick={handleNext}
                                    className="nav-button next-button"
                                >
                                    Επόμενη →
                                </button>
                            ) : (
                                <div className="submit-section">
                                    <label style={{display: 'none'}}>
                                        <input type="text" value={hp} onChange={(e) => setHp(e.target.value)} />
                                    </label>
                                    <Captcha onVerify={() => setIsVerified(true)} isVerified={isVerified} />
                                    <button className="submit-button" type="submit" disabled={!isVerified}>
                                        {isVerified ? "Υποβολή απαντήσεων" : "⏱"}
                                    </button>
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </main>
        </>
    );
};

export default ExamsForm